<template lang="pug">
  #app
    template(v-if="!this.$route.path.includes('login')")
      header-content
      div.flex-container
        nav-content
        ods-main
          ods-scrollbar(wrapClass="ods-scrollbar--main-content")
            router-view
            footer
            span.footer-version-number.ods-ml-4.ods-pb-7 {{ $t('msg_generics.actual_version') }} {{version}}
    div(v-else)
      router-view
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router/index'
import HeaderContent from '@/components/header/HeaderContent'
import NavContent from '@/components/nav/NavContent'
import fn from '../utils/functions'
import info from '../../package'
export default {
  name: 'the-b2b-app',

  components: {
    HeaderContent,
    NavContent
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canAdminParty',
      'canSearchInvoiceSales',
      'canSearchInvoicePurchases',
      'canSearchInvoiceThird',
      'canSearchRecadvSender',
      'canSearchRecadvReceiver',
      'canSearchOrderSender',
      'canSearchOrderReceiver',
      'canSearchDeliverySender',
      'canSearchDeliveryReceiver',
      'canSearchGenralSender',
      'canSearchGenralReceiver',
      'canSearchInvoiceDraft',
      'canSearchDocumentAuditory',
      'canSearchActionAuditory',
      'canAdminProject',
      'canAdminUser',
      'urlIn',
      'personalization',
      'jwt',
      'activeUser',
      'canSearchCMR',
      'optionsFilterService'
    ])
  },

  methods: {

    ...mapActions([
      // Carga de tema
      'writeThemeColors',
      // Facturas
      'getOptionsService',
      'getPersonalizations',
      'getOptionsFilterInvoiceStatus',
      'getOptionsInvoiceClasses',
      'getOptionsFilterInvoiceTaxType',
      'getOptionsFilterCurrency',
      'getOptionsFilterInvoiceType',
      // Usuarios
      'getPartiesService',
      'getCountries',
      'getOptionsFilterPaymentMethod',
      'resetSession',
      'chargeUrlIn',
      'jwtState',
      'resetPassChallenge',
      'recoveryPassUserState'
    ])
  },

  data () {
    return {
      version: info.version,
      appendStyles: true
    }
  },

  mounted () {
    if (this.appendStyles) {
      this.writeThemeColors()
      this.appendStyles = false
    }
  },

  async created () {
    // Comando para el Token de explorer
    document.execCommand('ClearAuthenticationCache', 'false')
    const load = this.$loading({
      lock: true,
      text: this.$t('login.logging')
    })
    try {
      const requestFilter = {
        page: 0,
        size: 1000,
        sort: 'name,ASC'
      }
      console.log('created de App')
      console.log('>>>>> this.urlIn: ', this.urlIn)
      console.log('>>>>> this.$apiBaseUrl: ', this.$apiBaseUrl)

      // comprobamos si ha expirado la contraseña
      if (this.activeUser.data && this.activeUser.data.passwordExpired) {
        console.log('por el if 1')
        console.log('la contraseña a expirado')
        await this.$notify({
          title: this.$t('error.password_expired'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 6000
        })
        await this.jwtState(null)
        router.push({
          name: 'change-password',
          params: {
            username: this.$route.params.username,
            password: this.$route.params.password,
            urlIn: this.urlIn
          }
        })
      } else {
        if (this.activeUser.authToken) {
          if (this.canAdminParty) {
            await this.getPartiesService(requestFilter)
          }
          const all = await Promise.all([
            await this.getPersonalizations(),
            this.getOptionsService(requestFilter),
            this.getOptionsFilterInvoiceStatus(),
            this.getOptionsInvoiceClasses(),
            this.getOptionsFilterInvoiceTaxType(),
            this.getOptionsFilterCurrency(),
            this.getOptionsFilterPaymentMethod(),
            this.getOptionsFilterInvoiceType(),
            this.getCountries()
          ]).catch(reason => {
            throw reason
          })
          console.log('RESPONSE PROMISES ALL: ', all)

          if (this.optionsFilterService.length === 1) {
            this.activeUser.data.projects = this.optionsFilterService
          }
          // Para acceder via link a tareas pendientes desde el email para Correos Express
          if (this.$route.params.invoiceId) {
            router.push({
              name: 'tareaspendientes-detail',
              params: {
                invoiceId: this.$route.params.invoiceId
              }
            })
          } else if (!this.$route.params.redirectedFrom || this.$route.params.redirectedFrom !== 'B2bPageDownloadInvoice') { // Para acceder desde el servicio REST del detalle de factura con el token
            console.log('>>> this.$route.params: ', this.$route.params)
            if (this.canSearchInvoiceSales) {
              router.push({
                name: 'facturas-emitidas-page'
              })
            } else if (this.canSearchInvoicePurchases) {
              router.push({
                name: 'facturas-recibidas-page'
              })
            } else if (this.canSearchInvoiceThird) {
              router.push({
                name: 'facturas-terceros-page'
              })
            } else if (this.canSearchRecadvReceiver) {
              router.push({
                name: 'recadvs-received-table'
              })
            } else if (this.canSearchRecadvSender) {
              router.push({
                name: 'recadvs-emit-table'
              })
            } else if (this.canSearchOrderReceiver) {
              router.push({
                name: 'orders-received-table'
              })
            } else if (this.canSearchOrderSender) {
              router.push({
                name: 'orders-emit-table'
              })
            } else if (this.canSearchGenralReceiver) {
              router.push({
                name: 'genrals-received-table'
              })
            } else if (this.canSearchGenralSender) {
              router.push({
                name: 'genrals-emit-table'
              })
            } else if (this.canSearchDeliverySender) {
              router.push({
                name: 'delivery-notes-emit-table'
              })
            } else if (this.canSearchDeliveryReceiver) {
              router.push({
                name: 'delivery-notes-received-table'
              })
            } else if (this.canSearchInvoiceDraft) {
              router.push({
                name: 'borradores-page'
              })
            } else if (this.canAdminUser) {
              router.push({
                name: 'usuarios-table'
              })
            } else if (this.canSearchCMR) {
              router.push({
                name: 'cmr-table'
              })
            } else if (this.canSearchDocumentAuditory) {
              router.push({
                name: 'auditorias-documentos-table'
              })
            } else if (this.canSearchActionAuditory) {
              router.push({
                name: 'auditorias-acciones-table'
              })
            } else if (this.canAdminProject) {
              router.push({
                name: 'servicios-table'
              })
            }
          }
        } else {
          if (this.$apiBaseUrl && this.$apiBaseUrl.includes('ree')) {
            await this.chargeUrlIn('redelectrica')
            router.push({ name: 'loginree' })
          } else if (this.$apiBaseUrl && this.$apiBaseUrl.includes('red.es')) {
            await this.chargeUrlIn('red.es')
            router.push({ name: 'loginredes' })
          } else {
            await this.chargeUrlIn(this.urlIn)
            if (this.urlIn == null || this.urlIn === undefined) {
              router.push({ name: 'login' })
            } else {
              router.push({ name: fn.assignLoginName(this.urlIn) })
            }
          }
        }
      }
    } catch (error) {
      console.log('ERROR PROMISES ALL: ', error)
      let urlOut = ''
      if (!error) {
        console.log('LOGIN CATCH IF: ', error)
        urlOut = this.urlIn
        await this.resetSession()
        await this.chargeUrlIn(urlOut)
        if (urlOut == null || urlOut === undefined) {
          router.push({ name: 'login' })
        } else {
          console.log(' antes de hacer push con nueva funcion')
          router.push({ name: fn.assignLoginName(urlOut) })
        }
      } else {
        let errorSms = ''
        let statusCode = null
        statusCode = error.status
        switch (statusCode) {
          case 400:
            errorSms = this.$t('error.e400')
            break
          case 403:
            errorSms = this.$t('error.e403_service')
            urlOut = this.urlIn
            await this.resetSession()
            await this.chargeUrlIn(urlOut)
            if (urlOut == null || urlOut === undefined) {
              router.push({ name: 'login' })
            } else {
              router.push({ name: fn.assignLoginName(urlOut) })
            }
            break
          case 401:
            errorSms = this.$t('error.e401')
            urlOut = this.urlIn
            await this.resetSession()
            await this.chargeUrlIn(urlOut)
            if (urlOut == null || urlOut === undefined) {
              router.push({ name: 'login' })
            } else {
              router.push({ name: fn.assignLoginName(urlOut) })
            }
            break
          case 500:
            errorSms = this.$t('error.e500')
            break
          default:
            errorSms = this.$t('error.default')
            break
        }
        this.$notify({
          title: errorSms,
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      }
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
_:-ms-fullscreen, :root {
  .ods-table__body {
    td {
      .ods-button.ods-tooltip.ods-button--text.is-round {
        line-height: 19px;
      }
    }
  }
  .ods-table{
    .ods-scrollbar {
      padding-bottom: 14px;
    }
  }
}
.flex-container {
  display: flex;
  &.space-between {
    justify-content: space-between;
  }
  &.space-around {
    justify-content: space-around;
  }
  &.space-evenly {
    justify-content: space-evenly;
  }
  &.wrap {
    flex-wrap: wrap;
  }
  &.flex-column {
    flex-direction: column;
    &--reverse {
      flex-direction: column-reverse;
    }
  }
  &.align-center {
    align-items: center;
  }
}

//BMG Footer version number
.footer-version-number {
  display: block;
  color: var(--color-bg-middle);
  font-size: rem(10);
}
</style>
